import * as CryptoJS from "crypto-js";
import { client } from "./client";

export function buildChargeRequestWithSignature(object, secretHashKey) {
  const signatureKeys = ["merchantCode", "merchantRefNum", "customerProfileId", "returnUrl", "itemId", "quantity", "price"];

  let signature = "";

  for (const key of signatureKeys) {
    if (object[key]) signature += object[key];
    else if (object?.chargeItems?.[0][key]) signature += object.chargeItems[0][key];
  }

  signature += secretHashKey;

  signature = CryptoJS.SHA256(signature).toString();

  return { ...object, signature };
}

function successCallBack(data) {
  console.log(data);
}
function failureCallBack(data) {
  console.log(data);
}

function checkout(object, onSuccess = successCallBack, onFailure = failureCallBack) {
  const configuration = {
    locale: "en",
    // divSelector: "fawry-payments",
    // eslint-disable-next-line no-undef
    mode: DISPLAY_MODE.POPUP,
    onSuccess: onSuccess,
    onFailure: onFailure
  };

  // eslint-disable-next-line no-undef
  FawryPay.checkout(object, configuration);
}

export async function buildChargeRequest(
  user = {},
  product = {},
  onSuccess = successCallBack,
  onFailure = failureCallBack,
) {
  const paymentMethodByPayment = await client("/Invoice/GetPaymentMethodByPaymentType", {
    params: {
      paymentTypeId: 2
    }
  });

  const merchantCode = paymentMethodByPayment?.response?.credential?.apiKey,
    paymentMethodId = paymentMethodByPayment?.response?.id;


  const PayAndSubscribeResults = await client("/Invoice/PayAndSubscribe", {
    data: {
      ...product,
      returnUrl: window.location.href,
      paymentMethodId
    }
  });

  const invoiceId = PayAndSubscribeResults?.response?.invoiceId;

  const payload = await buildChargeRequestWithSignature(
    {
      merchantCode: merchantCode,
      merchantRefNum: invoiceId,
      customerProfileId: user?.Id,
      customerName: user?.Name,
      customerEmail: user?.email,
      customerMobile: user?.Mobile,
      paymentMethod: "CARD",
      chargeItems: [
        {
          itemId: product?.applicationId,
          price: product?.total?.toFixed(2),
          quantity: 1
        }
      ],
      returnUrl: "https://developer.fawrystaging.com/checkout-success-popup"
    },
    "c46915b6-28ff-4081-8395-3bdc2d0ad865"
  );

  // eslint-disable-next-line no-undef
  return checkout(payload, onSuccess, onFailure);
}
